import './css/timeline.css'

export const CivicTimeline = () => {
    const steps = [
        { number: "1", title: "Request Demo", text: "See the platform in action" },
        { number: "2", title: "Customize", text: "Brand to your city's needs" },
        { number: "3", title: "Launch", text: "Go live in 30 days or less" },
        { number: "4", title: "Engage", text: "Connect with your community" }
    ];
    return (
        <div id="civic">
            {/* Mobile Version */}
            <div className="d-block d-lg-none section-container">
                <h1 className="text-white fw-bold">
                    Ready to Transform Civic Engagement?
                </h1>
                <h4 className="text-white my-5">
                    here & now brings your city's services, information, and participation
                        opportunities into one powerful app.
                </h4>
                <div className="mobile-timeline-wrapper">
                    <div className="mobile-timeline-container">
                        {steps.map(step => (
                            <div key={step.number} className="mobile-timeline-step">
                                <div className="mobile-square">{step.number}</div>
                                <div className="mobile-line"></div>
                                <div className="mobile-line-vertical"></div>
                                <h2 className="mobile-content">
                                    <b>{step.title}</b>
                                    <span>{step.text}</span>
                                </h2>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="text-white">
                    <p style={{ fontSize: "1.5rem" }}>Contact us today to get started!</p>
                </div>
            </div>

            {/* Desktop Version */}
            <div className="d-none d-lg-block section-container">
                <section className="desktop-why-cities-love">
                    <h1 className="text-white timeline-title fw-bold">
                        Ready to Transform Civic Engagement?
                    </h1>
                    <h4 className="text-white timeline-text-sub text-start">
                        here & now brings your city's services, information, and participation
                            opportunities into one powerful app.
                    </h4>
                    <div className="desktop-timeline-wrapper">
                        <div className="desktop-timeline-line"></div>

                        <div className="desktop-timeline-step up">
                            <div className="desktop-top-mini-step">
                                <h3>Request Demo</h3>
                                <h4 className="timeline-subtext-sm">See the platform in action</h4>
                            </div>
                            <div className="desktop-square desktop-square-up">1</div>
                        </div>

                        <div className="desktop-timeline-step down">
                            <div className="desktop-square desktop-square-down">2</div>
                            <div className="desktop-content-below">
                                <h3>Customize</h3>
                                <h4 className="timeline-subtext-sm">Brand to your city's needs</h4>
                            </div>
                        </div>

                        <div className="desktop-timeline-step up">
                            <div className="desktop-top-mini-step">
                                <h3>Launch</h3>
                                <h4 className="timeline-subtext-sm">Go live in 30 days or less</h4>
                            </div>
                            <div className="desktop-square desktop-square-up">3</div>
                        </div>

                        <div className="desktop-timeline-step down">
                            <div className="desktop-square desktop-square-down">4</div>
                            <div className="desktop-content-below">
                                <h3>Engage</h3>
                                <h4 className="timeline-subtext-sm">Connect with your community</h4>
                            </div>
                        </div>
                    </div>
                    <div className="title-center text-white">
                        <h1 className="timeline-title timeline-text-center">
                            Contact us today to get started!
                        </h1>
                    </div>
                </section>
            </div>
        </div>

    );
};
